import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/svg/next-w.svg")